import { concat, findIndex, get, groupBy, map, mapValues, uniq } from 'lodash';
import { Query } from 'redux-little-router';

import { Action } from '../actions';
import {
    ADD_SMART_FILTER,
    CHANGE_SMART_FILTER_TAB,
    CLOSE_GROUP_FILTER_INSPECTOR,
    OPEN_GROUP_FILTER_INSPECTOR,
    SELECT_AUTOBUDGET_PRIORITY_TYPE,
    SET_FILTER_FEED_CATEGORIES,
    SET_SMART_FILTER_VALIDATION_ERRORS,
    TOGGLE_SMART_FILTER_AVAILABLE,
    UPDATE_AUTOBUDGET_PRICE,
    UPDATE_FEED_FILTER_SCHEMA,
    UPDATE_FILTERS_ERROR,
    UPDATE_SMART_FILTER,
    UPDATE_SMART_FILTER_AUDITORY,
    UPDATE_SMART_FILTER_CATEGORIES,
    UPDATE_SMART_FILTER_NAME,
    UPDATE_SMART_FILTER_PRICE_RANGE,
    UPDATE_SMART_FILTER_SUCCESS,
    UPDATE_SMART_FILTER_VENDORS
} from '../actions/groupFilterInspector';
import {
    ACCEPT_MINUS_PHRASE_GROUPS_MASS_ACTIONS,
    AcceptMinusPhraseGroupsMassActionsAction
} from '../actions/groups-edit/groups-edit-mass-actions';
import {
    ChangeBannerFeedSearchTextAction,
    PERFORMANCE_CHANGE_BANNER_FEED_SEARCH_TEXT,
    PERFORMANCE_SET_VISIBLE_FEED_MODAL,
    PERFORMANCE_SET_VISIBLE_GROUP_BANNER_POPUP_FEED,
    PERFORMANCE_SUGGEST_FEED_ITEM_CLICK,
    PERFORMANCE_UPDATE_FEEDS,
    SetVisibleGroupBannerPopupFeedAction,
    SuggestFeedItemClickAction
} from '../actions/groups-edit/performance';
import {
    CLOSE_RECOMMENDATIONS_FOR_GROUPS_EDIT,
    CloseRecommendationsForGroupsEditAction,
    UPDATE_RECOMMENDATIONS_FOR_GROUPS_EDIT,
    UpdateRecommendationsForGroupsEditAction
} from '../actions/groups-edit/recommendations';
import {
    APPLY_SELECTOR_WIZARD_FOR_GROUP_EDIT,
    ApplySelectorWizardForGroupEdit,
    AUDIENCE_TARGETING_TEMPLATE_NAME_CHANGE,
    AudienceTargetingTemplateNameChange,
    CANCEL_GROUP_EDITOR_KEYWORDS,
    CancelGroupEditorKeywords,
    CHANGE_AUDIENCE_VALUE,
    CHANGE_GENERAL_RATE,
    CHANGE_GROUP_BANNER_HEADERS_FEED_FIELD,
    CHANGE_GROUP_BANNER_TEXT_FEED_FIELD,
    CHANGE_GROUP_EDIT_PAGE_STATUS,
    CHANGE_GROUP_EDITOR_KEYWORDS,
    CHANGE_GROUP_HREF_PARAMS,
    CHANGE_GROUP_NAME,
    CHANGE_GROUP_RETARGETING,
    CHANGE_GROUP_SAVED_STATUS,
    CHANGE_INPUT_GROUP_EDITOR_KEYWORDS,
    ChangeAudienceValueAction,
    ChangeGeneralRate,
    ChangeGroupBannerHeadersFeedFieldAction,
    ChangeGroupBannerTextFeedFieldAction,
    ChangeGroupEditorKeywords,
    ChangeGroupHrefParamsAction,
    ChangeGroupName,
    ChangeGroupRetargeting,
    ChangeGroupSavedStatus,
    ChangeInputGroupEditorKeywords,
    CLEAR_ERRORS_GROUP_EDITOR_REGIONS,
    CLEAR_GROUP_AUDIENCE_RETARGETING_CONDITION,
    ClearErrorsGroupEditorRegions,
    ClearGroupAudienceRetargetingCondition,
    CLOSE_GROUP_EDIT_RECOMMENDATION,
    CLOSE_GROUP_FILTERS_LIST_EDITOR,
    CREATE_SMART_AD_GROUP,
    DELETE_GROUP_FILTER,
    DELETE_RETARGETING_CONDITION_FROM_GROUP,
    DeleteRetargetingConditionFromGroup,
    DONE_GROUP_EDITOR_KEYWORDS,
    DoneGroupEditorKeywords,
    GET_CAMPAIGN_BASIC_DATA,
    GET_GROUP_FILTERS,
    GET_GROUPS_FOR_EDIT,
    INPUT_CHANGE_GROUP_EDITOR_MINUS_KEYWORDS,
    InputChangeGroupEditorMinusKeywords,
    MOVE_NEW_GROUP_TO_CREATED,
    MoveNewGroupToCreatedAction,
    OPEN_EDITOR_KEYWORDS,
    OPEN_GROUP_FILTERS_LIST_EDITOR,
    OpenGroupEditorKeywords,
    RESET_GROUPS_EDIT,
    RESET_RETARGETING_ERRORS,
    ResetRetargetingErrorsAction,
    SAVE_GROUPS,
    SET_GROUP_FILTERS,
    SHOW_GROUP_EDIT_ERROR,
    SHOW_GROUP_EDITOR_REGIONS_ERRORS,
    SHOW_GROUPS_CLIENT_VALIDATION_ERRORS,
    SHOW_GROUPS_PARTIAL_SAVE_RESULT,
    ShowGroupEditorRegionsErrors,
    TOGGLE_GROUP_AUTOTARGETING,
    ToggleGroupAutotargeting,
    UPDATE_DATA_FOR_EDIT_GROUPS,
    UPDATE_FILTERS_EDITOR_AUXILIARY_FILTER,
    UPDATE_GROUP_AUDIENCE_CRYPTA_AUDIO_GENRES,
    UPDATE_GROUP_AUDIENCE_CRYPTA_BEHAVIORAL,
    UPDATE_GROUP_AUDIENCE_CRYPTA_GROUP_FAMILY,
    UPDATE_GROUP_AUDIENCE_CRYPTA_SOCIAL_DEMO,
    UPDATE_GROUP_AUDIENCE_RETARGETING_CONDITION,
    UPDATE_GROUP_AUDIENCE_TARGETING_INTERESTS,
    UPDATE_GROUP_EDITOR_REGIONS,
    UPDATE_GROUP_INDOOR_MAP,
    UPDATE_GROUP_MINUS_PHRASES,
    UPDATE_GROUP_OUTDOOR_MAP,
    UPDATE_GROUP_RATE_CORRECTIONS,
    UPDATE_GROUP_TYPE,
    UPDATE_PRODUCT_RESTRICTION_ID,
    UPDATE_PRODUCTS_LIST,
    UPDATE_RETARGETING_CONDITIONS,
    UPDATE_RETARGETING_CONDITIONS_FOR_EDIT_GROUPS,
    UPDATE_SHOW_CONDITION_TYPE,
    UpdateGroupAudienceCryptaAudioGenres,
    UpdateGroupAudienceCryptaBehavioral,
    UpdateGroupAudienceCryptaGroupFamily,
    UpdateGroupAudienceCryptaSocialDemo,
    UpdateGroupAudienceRetargetingCondition,
    UpdateGroupAudienceTargetingInterests,
    UpdateGroupEditorRegions,
    UpdateGroupIndoorMap,
    UpdateGroupMinusPhrases,
    UpdateGroupOutdoorMap,
    UpdateGroupRateCorrectionsAction,
    UpdateGroupTypeAction,
    UpdateProductRestrictionIdAction,
    UpdateShowConditionTypeAction
} from '../actions/groupsEdit';
import {
    CANCEL_ADDITIONAL_TARGETING_CHANGES,
    CHANGE_ADDITIONAL_TARGETING_UIDS_CONTROL,
    CHANGE_ADDITIONAL_TARGETING_UIDS_VALUE,
    CHANGE_BROWSER_ENGINES_CONTROL,
    CHANGE_BROWSER_ENGINES_VALUE,
    CHANGE_BROWSER_NAMES_CONTROL,
    CHANGE_BROWSER_NAMES_VALUE,
    CHANGE_DEVICE_NAMES_CONTROL,
    CHANGE_DEVICE_NAMES_VALUE,
    CHANGE_DEVICE_VENDORS_CONTROL,
    CHANGE_DEVICE_VENDORS_VALUE,
    CHANGE_INTERFACE_LANGS_CONTROL,
    CHANGE_INTERFACE_LANGS_VALUE,
    CHANGE_INTERNAL_NETWORK_CONTROL,
    CHANGE_IS_BROWSER_CONTROL,
    CHANGE_IS_MOBILE_CONTROL,
    CHANGE_IS_TABLET_CONTROL,
    CHANGE_IS_TOUCH_CONTROL,
    CHANGE_OS_FAMILIES_CONTROL,
    CHANGE_OS_FAMILIES_VALUE,
    CHANGE_OS_NAMES_CONTROL,
    CHANGE_OS_NAMES_VALUE,
    CHANGE_PRIORITY_VALUE,
    CHANGE_QUERY_REFERERS_CONTROL,
    CHANGE_QUERY_REFERERS_VALUE,
    CHANGE_USER_AGENTS_CONTROL,
    CHANGE_USER_AGENTS_VALUE,
    CLOSE_ADDITIONAL_TARGETING_INTERNAL,
    OPEN_ADDITIONAL_TARGETING_INTERNAL,
    SAVE_ADDITIONAL_TARGETING_CHANGES,
    SAVE_INTERNAL_GROUPS
} from '../actions/groupsEditInternal';
import {
    CLEAR_INDOOR_ERRORS,
    ClearIndoorErrors
} from '../actions/indoorMapEditor';
import {
    CLEAR_OUTDOOR_ERRORS,
    ClearOutdoorErrors
} from '../actions/outdoorMapEditor';
import {
    ADD_SMART_FILTER_CONDITION,
    CHANGE_SMART_FILTER_CONDITION_FIELD,
    CHANGE_SMART_FILTER_CONDITION_OPERATOR,
    CHANGE_SMART_FILTER_CONDITION_VALUES,
    REMOVE_SMART_FILTER_CONDITION
} from '../actions/smartFilterConditions';
import { BulkReplacementRadio } from '../components/BulkReplacementModeChooser/BulkReplacementModeChooser';
import {
    getCurrentRateTypeAndLists,
    makeEmptySmartFilterItem
} from '../mappers/group/group';
import { getRestrictionByShowConditionType } from '../mappers/products/products-list-mapper';
import { selectEditGroup } from '../selectors/groupEdit/group/group';
import { getGroupFieldValidationErrors } from '../service/GroupEditErrors/ClientGroupEditErrors/ClientGroupEditErrors';
import { GroupIdsForGroupsEditHelpers } from '../service/GroupIdsForGroupsEditHelpers';
import { GroupsHelpers } from '../service/GroupsHelpers/GroupsHelpers';
import { PlacementsMapHelpers } from '../service/PlacementsMap/PlacementsMap';
import { RegionsHelpers } from '../service/RegionsHelpers/RegionsHelpers';
import { AudienceTargetingsType } from '../typings/audienceTargetings';
import {
    ErrorsEdit,
    PageStatus,
    ValidationErrorData,
    ValidationErrorsData
} from '../typings/common';
import { CampaignType, GroupType } from '../typings/domain';
import {
    GdBidModifierType,
    GdCampaignPlatform,
    GdCampaignStrategyType
} from '../typings/graphql-grid';
import { GroupId, GroupsScreenUrlSearchQueryParams } from '../typings/groups';
import {
    CpmGroupShowConditionType,
    EditGroupData,
    EditGroupKeywords,
    EditGroupsState,
    getEditGroupDataValueWithMinusPhrases,
    MassActionId
} from '../typings/groupsEditState';
import { RetargetingValue } from '../typings/log';
import {
    MinusPhrasesLibraryItem,
    MinusPhrasesShortLibraryItem
} from '../typings/minusPhraseLibrary';
import { State } from '../typings/state';

import { conditionsReducer } from './groups-edit/conditions';
import { filtersReducer } from './groups-edit/filters';
import { groupFilterInspectorReducer } from './groups-edit/groupFilterInspector';
import { groupsEditInternal } from './groups-edit/internal';

export interface EditGroupPageLocalAndUrlData {
    campaignsIds: string[];
    groupsIds: string[];
    isNew: boolean;
    isNewEmptyGroup: boolean;
}

export const getEditGroupPageData = (
    queryParams: Query
): EditGroupPageLocalAndUrlData => {
    const editGroupsLocalData = GroupIdsForGroupsEditHelpers.getCampAndGroupIds(
        queryParams.ulogin
    );

    const editGroupDataFromUrl = {
        campaignsIds: queryParams[GroupsScreenUrlSearchQueryParams.campaignsIds]
            ? queryParams[GroupsScreenUrlSearchQueryParams.campaignsIds].split(
                  ','
              )
            : [],
        groupsIds: queryParams[GroupsScreenUrlSearchQueryParams.groupsIds]
            ? queryParams[GroupsScreenUrlSearchQueryParams.groupsIds].split(',')
            : [],
        isNew: queryParams[GroupsScreenUrlSearchQueryParams.isNew]
            ? Boolean(+queryParams[GroupsScreenUrlSearchQueryParams.isNew])
            : false,
        isNewEmptyGroup: queryParams[
            GroupsScreenUrlSearchQueryParams.isNewEmptyGroup
        ]
            ? Boolean(
                  +queryParams[GroupsScreenUrlSearchQueryParams.isNewEmptyGroup]
              )
            : false
    };

    const hasNotEmptyEditGroupDataFromUrl =
        editGroupDataFromUrl.campaignsIds.length !== 0 ||
        editGroupDataFromUrl.groupsIds.length !== 0;

    return hasNotEmptyEditGroupDataFromUrl
        ? editGroupDataFromUrl
        : editGroupsLocalData;
};

export const EditGroupsInitialState: EditGroupsState = {
    pageStatus: PageStatus.LOADING,
    errors: [],
    groups: {},
    groupFilterInspector: {
        filter: makeEmptySmartFilterItem({
            platform: GdCampaignPlatform.BOTH,
            strategy: GdCampaignStrategyType.AVG_CPC_PER_CAMP
        }),
        isOpen: false,
        inspectorStatus: PageStatus.LOADED,
        schema: {
            fields: []
        }
    },
    groupsIds: [],
    campaignsIds: [],
    isNew: false,
    isNewEmptyGroup: false,
    retargetingConditions: undefined,
    recommendations: {},
    feedsIds: [],
    feeds: {},
    feedsPopupFetchFirstRun: true,
    isPerformanceFeedModalOpen: false,
    allowedRateCorrectionsData: {} as Record<
        GroupType,
        Array<GdBidModifierType>
    >,
    rateCorrectionsConstants: {},
    keywordsCountLimit: 0
};

const changeAudienceValue = (
    state: EditGroupsState,
    action: ChangeAudienceValueAction
): EditGroupsState => {
    const group = selectEditGroup(state, action.groupId);
    const groupValue = group.value;

    if (groupValue.campaignType !== CampaignType.CPM_BANNER) {
        throw Error(
            `В кампании с типом ${
                groupValue.campaignType
            } нет возможности установить охват группы`
        );
    }

    const audienceCollection = action.value;

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                value: {
                    ...groupValue,
                    audienceCollection
                }
            }
        }
    };
};

const updateGroupName = (
    state: EditGroupsState,
    action: ChangeGroupName
): EditGroupsState => {
    const { name, ...otherFieldsGroupErrors } = state.groups[
        action.groupId
    ].errors;

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...state.groups[action.groupId],
                value: {
                    ...state.groups[action.groupId].value,
                    name: action.name
                },
                errors: otherFieldsGroupErrors
            }
        }
    };
};

const updateGroupType = (
    state: EditGroupsState,
    action: UpdateGroupTypeAction
): EditGroupsState => {
    const {
        group: { restrictionId }
    } = action;
    const { name, ...otherFieldsGroupErrors } = state.groups[
        action.groupId
    ].errors;
    const { groups, productsList } = state;
    const group = groups[action.groupId];

    if (
        group.value.campaignType !== CampaignType.CPM_BANNER ||
        productsList === undefined
    ) {
        throw Error(
            `В группе с типом ${
                group.value.campaignType
            } нет возможности изменить тип обьявления`
        );
    }

    const { rateCurrentType, rateCorrections } = getCurrentRateTypeAndLists({
        productRestrictionId: restrictionId,
        rateCorrectionsFromApi: [],

        productsList: productsList
    });

    return {
        ...state,
        groups: {
            ...groups,
            [action.groupId]: {
                ...group,
                value: {
                    ...group.value,
                    rateCurrentType,
                    rateCorrections,
                    groupType: action.group.groupType
                },
                errors: otherFieldsGroupErrors
            }
        }
    };
};

const audienceTargetingTemplateNameChange = (
    state: EditGroupsState,
    action: AudienceTargetingTemplateNameChange
): EditGroupsState => {
    const group = state.groups[action.groupId];

    if (group.value.campaignType !== CampaignType.CPM_BANNER) {
        throw new Error('invalid group type');
    }

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                value: {
                    ...group.value,
                    audienceTargetingsTemplateName: action.value
                },
                errors: getGroupsErrorsWithoutCurrentListErrors(group.errors, [
                    'retargetingConditionName'
                ])
            }
        }
    };
};

const clearGroupAudienceRetargetingCondition = (
    state: EditGroupsState,
    action: ClearGroupAudienceRetargetingCondition
): EditGroupsState => {
    const group = state.groups[action.groupId];
    const groupValue = group.value;

    if (groupValue.campaignType !== CampaignType.CPM_BANNER) {
        throw Error(
            `В кампании с типом ${
                groupValue.campaignType
            } нет возможности очистить Яндекс.Аудитории и Яндекс.Метрика`
        );
    }
    const audienceTargetings = groupValue.audienceTargetings || {};

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                value: {
                    ...groupValue,
                    audienceTargetings: {
                        ...audienceTargetings,
                        [AudienceTargetingsType.audienceMetrics]: undefined
                    }
                }
            }
        }
    };
};

const updateGroupGeneralRate = (
    state: EditGroupsState,
    action: ChangeGeneralRate
): EditGroupsState => {
    const newGroupData = {
        ...state.groups[action.groupId],
        value: {
            ...state.groups[action.groupId].value,
            generalRate: action.generalRate
        }
    };
    const validationErrors = getGroupFieldValidationErrors(
        newGroupData,
        'generalRate',
        action.validationParams
    );
    const { generalRate, ...otherFieldsGroupErrors } = state.groups[
        action.groupId
    ].errors;

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...newGroupData,
                errors:
                    validationErrors.length === 0
                        ? otherFieldsGroupErrors
                        : {
                              ...otherFieldsGroupErrors,
                              generalRate: { errors: validationErrors }
                          }
            }
        }
    };
};

const doneChangesGroupMinusKeywordsEditor = (
    state: EditGroupsState,
    action: UpdateGroupMinusPhrases
): EditGroupsState => {
    if (action.groupId === MassActionId.groupsEdit) {
        return state;
    }

    const group = state.groups[action.groupId];
    const { minusKeywordsEditor, libraryItems } = action;
    const groupValue = getEditGroupDataValueWithMinusPhrases(group.value);
    if (!groupValue) {
        throw new Error('invalid group type');
    }

    if (minusKeywordsEditor.selectedLibraryListItems) {
        const selectedLibraryList = minusKeywordsEditor.selectedLibraryListItems.reduce(
            (
                selectedElems: MinusPhrasesShortLibraryItem[],
                id: string
            ): MinusPhrasesShortLibraryItem[] => {
                const selectedItem = libraryItems.find(
                    (item: MinusPhrasesLibraryItem) => item.id === id
                );

                if (selectedItem) {
                    selectedElems.push({
                        id,
                        name: selectedItem.name
                    });
                }

                return selectedElems;
            },
            [] as MinusPhrasesShortLibraryItem[]
        );

        return {
            ...state,
            groups: {
                ...state.groups,
                [action.groupId]: {
                    ...group,
                    value: {
                        ...groupValue,
                        minusKeywords: minusKeywordsEditor.value,
                        selectedLibraryList
                    }
                }
            }
        };
    } else {
        return {
            ...state,
            groups: {
                ...state.groups,
                [action.groupId]: {
                    ...group,
                    value: {
                        ...groupValue,
                        minusKeywords: minusKeywordsEditor.value
                    }
                }
            }
        };
    }
};

const inputChangeGroupMinusKeywordsEditor = (
    state: EditGroupsState,
    action: InputChangeGroupEditorMinusKeywords
): EditGroupsState => {
    if (action.groupId === MassActionId.groupsEdit) {
        return state;
    }

    const group = state.groups[action.groupId];

    const { errors } = group;

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                errors: getGroupsErrorsWithoutCurrentListErrors(errors, [
                    'minusKeywords'
                ])
            }
        }
    };
};

const setSavedGroups = (
    state: EditGroupsState,
    updatedGroupIds: Array<GroupId>,
    errors: ErrorsEdit
): EditGroupsState => {
    if (updatedGroupIds.length) {
        const groups = { ...state.groups };

        updatedGroupIds.forEach(groupId => {
            groups[groupId] = {
                ...state.groups[groupId],
                isSaved: true
            };
        });

        state = {
            ...state,
            groups
        };
    }

    if (errors.common) {
        state = {
            ...state,
            pageStatus: PageStatus.LOADED,
            errors: [
                ...state.errors,
                ...get(errors, 'common.errors').map(
                    ({ text }: ValidationErrorData) => text
                )
            ]
        };
    }

    if (errors.groups) {
        Object.keys(errors.groups).forEach(groupId => {
            if (groupId !== 'errors') {
                const errorsObj = get(errors, `groups[${groupId}]`, []);
                const group = state.groups[groupId];

                state = {
                    ...state,
                    pageStatus: PageStatus.LOADED,
                    groups: {
                        ...state.groups,
                        [groupId]: {
                            ...group,
                            isSaved: false,
                            errors: errorsObj
                        }
                    }
                };
            }
        });
    }

    return state;
};

const updateGroupSavedStatus = (
    state: EditGroupsState,
    action: ChangeGroupSavedStatus
): EditGroupsState => {
    const group = state.groups[action.groupId];

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                isSaved: !group.isSaved
            }
        }
    };
};

const doneGroupKeywords = (
    state: EditGroupsState,
    action: DoneGroupEditorKeywords
): EditGroupsState => {
    const group = state.groups[action.groupId];
    if (
        group.value.campaignType !== CampaignType.TEXT &&
        group.value.campaignType !== CampaignType.CPM_BANNER
    ) {
        throw new Error('invalid group type');
    }

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                value: {
                    ...group.value,
                    keywords: group.keywordsEditor.value
                },
                keywordsEditor: {
                    ...group.keywordsEditor,
                    isOpen: false
                }
            }
        }
    };
};

const cancelGroupKeywordsEditor = (
    state: EditGroupsState,
    action: CancelGroupEditorKeywords
): EditGroupsState => {
    const group = state.groups[action.groupId];
    const groupValue = group.value;

    if (
        groupValue.campaignType !== CampaignType.TEXT &&
        groupValue.campaignType !== CampaignType.CPM_BANNER
    ) {
        throw Error(
            `В кампании с типом ${
                groupValue.campaignType
            } нет условий ретаргетинга`
        );
    }

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                keywordsEditor: {
                    ...group.keywordsEditor,
                    value: groupValue.keywords || [],
                    input: GroupsHelpers.getInputStringFromPhrasesList(
                        groupValue.keywords || []
                    ),
                    isOpen: false
                }
            }
        }
    };
};

const updateRecommendationData = (
    state: EditGroupsState,
    action: UpdateRecommendationsForGroupsEditAction
): EditGroupsState => {
    return {
        ...state,
        recommendations: action.recommendations
    };
};

const closeGroupsEditRecommendations = (
    state: EditGroupsState,
    action: CloseRecommendationsForGroupsEditAction
): EditGroupsState => {
    const recommendation = state.recommendations[action.id];

    return {
        ...state,
        recommendations: {
            ...state.recommendations,
            [action.id]: {
                ...recommendation,
                isRecommendationsVisible: false
            }
        }
    };
};

const updateGroupKeywordsEditor = (
    state: EditGroupsState,
    action: ChangeGroupEditorKeywords
): EditGroupsState => {
    const group = state.groups[action.groupId];
    const { keywordsEditor } = group;
    const { input } = keywordsEditor;
    const keywordsData = GroupsHelpers.parsePhrasesFromInputString(input);
    const newListKeywords = getUniqKeywordsData(
        keywordsEditor.value,
        keywordsData
    );

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                keywordsEditor: {
                    ...group.keywordsEditor,
                    value: newListKeywords,
                    input: GroupsHelpers.getInputStringFromPhrasesList(
                        newListKeywords
                    )
                }
            }
        }
    };
};

const getUniqKeywordsData = (
    actualListKeywords: EditGroupKeywords[],
    keywordsData: Array<{ phrase: string; minusWords: Array<string> }>
): EditGroupKeywords[] => {
    const matchingKeyPhraseToIdHash = actualListKeywords.reduce(
        (acc, itemKeyword) => {
            if (itemKeyword.id && itemKeyword.phrase) {
                acc[itemKeyword.phrase] = itemKeyword.id;
            }

            return acc;
        },
        {}
    );

    const listKeywords = groupBy(keywordsData, 'phrase');

    return map(listKeywords, (keywordData, keyword) => {
        return {
            id: matchingKeyPhraseToIdHash[keyword],
            phrase: keyword,
            minusWords: uniq(
                keywordData.reduce(
                    (res, { minusWords }) => [...res, ...minusWords],
                    []
                )
            )
        };
    });
};

const applyGroupKeywordsFromSelectorWizard = (
    state: EditGroupsState,
    action: ApplySelectorWizardForGroupEdit,
    fullState: State
): EditGroupsState => {
    const group = state.groups[action.groupId];
    const newListKeywords = getUniqKeywordsData(
        group.keywordsEditor.value,
        group.keywordsEditor.value.concat(
            action.listChosenKeywords.map(listChosenKeyword => ({
                phrase: listChosenKeyword,
                minusWords: []
            }))
        )
    );

    const editorData = fullState.minusPhraseLibraryEditor.data;
    const minusKeywordsEditor =
        editorData && editorData[action.groupId].minusKeywordsEditor;
    const isMinusWordsEditorOpen =
        minusKeywordsEditor && minusKeywordsEditor.isOpen;
    const groupWithMinusPhrases = getEditGroupDataValueWithMinusPhrases(
        group.value
    );
    let existingMinusWords: string[] = [];

    if (groupWithMinusPhrases) {
        existingMinusWords = isMinusWordsEditorOpen
            ? minusKeywordsEditor.value
            : groupWithMinusPhrases.minusKeywords;
    }

    const newMinusPhrases = concat(existingMinusWords, action.minusPhrases);

    const keywordsChange = group.keywordsEditor.isOpen
        ? {}
        : {
              keywords: newListKeywords
          };

    const minusPhrasesChange = isMinusWordsEditorOpen
        ? {}
        : {
              minusKeywords: newMinusPhrases
          };

    const groupChange = {
        keywordsEditor: {
            ...group.keywordsEditor,
            value: newListKeywords,
            input: GroupsHelpers.getInputStringFromPhrasesList(newListKeywords)
        },
        errors: getGroupsErrorsWithoutCurrentListErrors(group.errors, [
            'keywords'
        ]),
        value: {
            ...state.groups[action.groupId].value,
            ...keywordsChange,
            ...minusPhrasesChange
        }
    };

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...state.groups[action.groupId],
                ...groupChange
            }
        }
    };
};

const openGroupOpenKeywordsEditor = (
    state: EditGroupsState,
    action: OpenGroupEditorKeywords
): EditGroupsState => {
    const group = state.groups[action.groupId];

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                keywordsEditor: {
                    ...group.keywordsEditor,
                    isOpen: true
                }
            }
        }
    };
};

const getGroupsErrorsWithoutCurrentListErrors = (
    errors: ValidationErrorsData,
    currentListErrors: Array<string>
): ValidationErrorsData => {
    return Object.keys(errors).reduce((acc, errorKey) => {
        if (!currentListErrors.includes(errorKey)) {
            acc[errorKey] = errors[errorKey];
        }
        return acc;
    }, {});
};

const inputChangeGroupKeywordsEditor = (
    state: EditGroupsState,
    action: ChangeInputGroupEditorKeywords
): EditGroupsState => {
    const group = state.groups[action.groupId];
    const { errors } = group;

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                keywordsEditor: {
                    ...group.keywordsEditor,
                    input: action.value
                },
                errors: getGroupsErrorsWithoutCurrentListErrors(errors, [
                    'keywords'
                ])
            }
        }
    };
};

const updateRateCorrections = (
    state: EditGroupsState,
    action: UpdateGroupRateCorrectionsAction
): EditGroupsState => {
    const group = state.groups[action.groupId];
    const groupValue = group.value;

    if (
        groupValue.campaignType !== CampaignType.TEXT &&
        groupValue.campaignType !== CampaignType.PERFORMANCE &&
        groupValue.campaignType !== CampaignType.CPM_BANNER
    ) {
        throw Error(
            `В кампании с типом ${
                groupValue.campaignType
            } нет возможности установить корректировки ставок`
        );
    }

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                value: {
                    ...groupValue,
                    rateCorrections: action.rateCorrections
                }
            }
        }
    };
};

const updateGroupAudienceRetargetingCondition = (
    state: EditGroupsState,
    action: UpdateGroupAudienceRetargetingCondition
): EditGroupsState => {
    const group = state.groups[action.id];
    const groupValue = group.value;

    if (groupValue.campaignType !== CampaignType.CPM_BANNER) {
        throw Error(
            `В кампании с типом ${
                groupValue.campaignType
            } нет возможности установить Яндекс.Аудитории и Яндекс.Метрика`
        );
    }

    const audienceTargetings = groupValue.audienceTargetings || {};

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.id]: {
                ...group,
                value: {
                    ...groupValue,
                    audienceTargetings: {
                        ...audienceTargetings,
                        [AudienceTargetingsType.audienceMetrics]:
                            action.conditionData
                    }
                },
                errors: getGroupsErrorsWithoutCurrentListErrors(group.errors, [
                    'retargetingCondition'
                ])
            }
        }
    };
};

const updateInterestsTargetingSet = (
    state: EditGroupsState,
    action: UpdateGroupAudienceTargetingInterests
): EditGroupsState => {
    const group = state.groups[action.id];
    const groupValue = group.value;

    if (groupValue.campaignType !== CampaignType.CPM_BANNER) {
        throw Error(
            `В кампании с типом ${
                groupValue.campaignType
            } нет возможности установить интересы`
        );
    }

    const audienceTargetings = groupValue.audienceTargetings || {};

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.id]: {
                ...group,
                value: {
                    ...groupValue,
                    audienceTargetings: {
                        ...audienceTargetings,
                        [AudienceTargetingsType.interests]: action.interests
                    }
                },
                errors: getGroupsErrorsWithoutCurrentListErrors(group.errors, [
                    'retargetingCondition'
                ])
            }
        }
    };
};

const updateCryptaSocialDemo = (
    state: EditGroupsState,
    action: UpdateGroupAudienceCryptaSocialDemo
): EditGroupsState => {
    const group = state.groups[action.id];
    const groupValue = group.value;

    if (groupValue.campaignType !== CampaignType.CPM_BANNER) {
        throw Error(
            `В кампании с типом ${
                groupValue.campaignType
            } нет возможности установить социально-демографический профиль`
        );
    }

    const audienceTargetings = groupValue.audienceTargetings || {};

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.id]: {
                ...group,
                value: {
                    ...groupValue,
                    audienceTargetings: {
                        ...audienceTargetings,
                        [AudienceTargetingsType.socialDemo]: action.socialDemo
                    }
                },
                errors: getGroupsErrorsWithoutCurrentListErrors(group.errors, [
                    'retargetingCondition'
                ])
            }
        }
    };
};

const updateGroupOutdoorMap = (
    state: EditGroupsState,
    action: UpdateGroupOutdoorMap
): EditGroupsState => {
    const group = state.groups[action.id];
    const groupValue = group.value;

    if (groupValue.campaignType !== CampaignType.CPM_BANNER) {
        throw Error(
            `В кампании с типом ${
                groupValue.groupType
            } нет возможности установить рекламные поверхности`
        );
    }

    const outdoorMap = groupValue.outdoorMap || {};

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.id]: {
                ...group,
                value: {
                    ...groupValue,
                    outdoorMap: {
                        ...outdoorMap,
                        pageBlocks: PlacementsMapHelpers.checkedByRegionToPageBlocks(
                            action.checkedByRegion
                        )
                    }
                }
            }
        }
    };
};

const clearGroupMapErrors = (
    state: EditGroupsState,
    action: ClearIndoorErrors | ClearOutdoorErrors
): EditGroupsState => {
    const group = state.groups[action.id];

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.id]: {
                ...group,
                errors: {
                    ...group.errors,
                    pageBlocks: {
                        errors: []
                    }
                }
            }
        }
    };
};

const updateGroupIndoorMap = (
    state: EditGroupsState,
    action: UpdateGroupIndoorMap
): EditGroupsState => {
    const group = state.groups[action.id];
    const groupValue = group.value;

    if (groupValue.campaignType !== CampaignType.CPM_BANNER) {
        throw Error(
            `В кампании с типом ${
                groupValue.groupType
            } нет возможности установить рекламные поверхности`
        );
    }

    const indoorMap = groupValue.indoorMap || {};

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.id]: {
                ...group,
                value: {
                    ...groupValue,
                    indoorMap: {
                        ...indoorMap,
                        pageBlocks: PlacementsMapHelpers.indoorCheckedByRegionToPageBlocks(
                            action.screenGroupsByRegion,
                            action.checkedByRegion
                        )
                    }
                }
            }
        }
    };
};

const updateCryptaGroupFamily = (
    state: EditGroupsState,
    action: UpdateGroupAudienceCryptaGroupFamily
): EditGroupsState => {
    const group = state.groups[action.id];
    const groupValue = group.value;

    if (groupValue.campaignType !== CampaignType.CPM_BANNER) {
        throw Error(
            `В кампании с типом ${
                groupValue.campaignType
            } нет возможности установить данные о семье и профессии`
        );
    }

    const audienceTargetings = groupValue.audienceTargetings || {};

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.id]: {
                ...group,
                value: {
                    ...groupValue,
                    audienceTargetings: {
                        ...audienceTargetings,
                        [AudienceTargetingsType.family]: action.groupFamily
                    }
                },
                errors: getGroupsErrorsWithoutCurrentListErrors(group.errors, [
                    'retargetingCondition'
                ])
            }
        }
    };
};

const updateCrcryptaAudioGenres = (
    state: EditGroupsState,
    action: UpdateGroupAudienceCryptaAudioGenres
): EditGroupsState => {
    const group = state.groups[action.id];
    const groupValue = group.value;

    if (groupValue.campaignType !== CampaignType.CPM_BANNER) {
        throw Error(
            `В кампании с типом ${
                groupValue.campaignType
            } нет возможности установить данные о жанрах`
        );
    }

    const audienceTargetings = groupValue.audienceTargetings || {};

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.id]: {
                ...group,
                value: {
                    ...groupValue,
                    audienceTargetings: {
                        ...audienceTargetings,
                        [AudienceTargetingsType.audioGenres]: action.audioGenres
                    }
                }
            }
        }
    };
};

const updateCryptaBehavioral = (
    state: EditGroupsState,
    action: UpdateGroupAudienceCryptaBehavioral
): EditGroupsState => {
    const group = state.groups[action.id];
    const groupValue = group.value;

    if (groupValue.campaignType !== CampaignType.CPM_BANNER) {
        throw Error(
            `В кампании с типом ${
                groupValue.campaignType
            } нет возможности установить поведенческие признаки`
        );
    }

    const audienceTargetings = groupValue.audienceTargetings || {};

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.id]: {
                ...group,
                value: {
                    ...groupValue,
                    audienceTargetings: {
                        ...audienceTargetings,
                        [AudienceTargetingsType.behaviors]: action.behavioral
                    }
                },
                errors: getGroupsErrorsWithoutCurrentListErrors(group.errors, [
                    'retargetingConditionName'
                ])
            }
        }
    };
};

const toggleGroupAutotargeting = (
    state: EditGroupsState,
    action: ToggleGroupAutotargeting
): EditGroupsState => {
    const group = state.groups[action.groupId];

    if (group.value.campaignType !== CampaignType.TEXT) {
        throw Error(
            `В кампании с типом ${
                group.value.campaignType
            } нет возможности установить автотаргетинг`
        );
    }

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                value: {
                    ...group.value,
                    autotargeting: {
                        ...group.value.autotargeting,
                        isActive: !group.value.autotargeting.isActive
                    }
                }
            }
        }
    };
};

const updateGroupRetargeting = (
    state: EditGroupsState,
    action: ChangeGroupRetargeting
): EditGroupsState => {
    const group = state.groups[action.groupId];

    if (group.value.campaignType !== CampaignType.TEXT) {
        throw Error(
            `В кампании с типом ${
                group.value.campaignType
            } нет возможности установить условия ретаргетинга`
        );
    }

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                value: {
                    ...group.value,
                    retargeting: action.value
                }
            }
        }
    };
};

const updateGroupHrefParams = (
    state: EditGroupsState,
    action: ChangeGroupHrefParamsAction
): EditGroupsState => {
    const group = state.groups[action.groupId];

    switch (group.value.campaignType) {
        case CampaignType.PERFORMANCE:
            return {
                ...state,
                groups: {
                    ...state.groups,
                    [action.groupId]: {
                        ...group,
                        value: {
                            ...group.value,
                            hrefParams: action.params
                        }
                    }
                }
            };
        default:
            return state;
    }
};

const updateGroupBannerHeadersFeedField = (
    state: EditGroupsState,
    action: ChangeGroupBannerHeadersFeedFieldAction
): EditGroupsState => {
    const group = state.groups[action.groupId];

    switch (group.value.campaignType) {
        case CampaignType.PERFORMANCE:
            return {
                ...state,
                groups: {
                    ...state.groups,
                    [action.groupId]: {
                        ...group,
                        value: {
                            ...group.value,
                            bannerHeadersFeedField: action.payload
                        }
                    }
                }
            };
        default:
            return state;
    }
};

const updateGroupBannerTextFeedField = (
    state: EditGroupsState,
    action: ChangeGroupBannerTextFeedFieldAction
): EditGroupsState => {
    const group = state.groups[action.groupId];

    switch (group.value.campaignType) {
        case CampaignType.PERFORMANCE:
            return {
                ...state,
                groups: {
                    ...state.groups,
                    [action.groupId]: {
                        ...group,
                        value: {
                            ...group.value,
                            bannerTextFeedField: action.payload
                        }
                    }
                }
            };
        default:
            return state;
    }
};

const performanceSetVisibleGroupBannerPopupFeed = (
    state: EditGroupsState,
    action: SetVisibleGroupBannerPopupFeedAction
): EditGroupsState => {
    const group = state.groups[action.groupId];

    switch (group.value.campaignType) {
        case CampaignType.PERFORMANCE:
            return {
                ...state,
                groups: {
                    ...state.groups,
                    [action.groupId]: {
                        ...group,
                        value: {
                            ...group.value,
                            feedsPopupIsOpen: action.isVisible
                        }
                    }
                }
            };
        default:
            return state;
    }
};

const performanceChangeBannerFeedSearchText = (
    state: EditGroupsState,
    action: ChangeBannerFeedSearchTextAction
): EditGroupsState => {
    const group = state.groups[action.groupId];

    switch (group.value.campaignType) {
        case CampaignType.PERFORMANCE:
            return {
                ...state,
                groups: {
                    ...state.groups,
                    [action.groupId]: {
                        ...group,
                        value: {
                            ...group.value,
                            searchFeedFieldValue: action.value
                        }
                    }
                }
            };
        default:
            return state;
    }
};

const updateGroupEditorRegions = (
    state: EditGroupsState,
    action: UpdateGroupEditorRegions
): EditGroupsState => {
    const group = state.groups[action.groupId];

    const regionIds = RegionsHelpers.convertRegionsSelectedInfoToFlattenList(
        RegionsHelpers.getSelectedRegionsInfo(action.tree, action.selectedMap)
    );

    switch (group.value.campaignType) {
        case CampaignType.TEXT:
        case CampaignType.PERFORMANCE:
        case CampaignType.INTERNAL_FREE:
        case CampaignType.INTERNAL_DISTRIB:
        case CampaignType.CPM_BANNER:
            return {
                ...state,
                groups: {
                    ...state.groups,
                    [action.groupId]: {
                        ...group,
                        value: {
                            ...group.value,
                            regions: {
                                ...group.value.regions,
                                selectedMap: action.selectedMap,
                                regionIds: regionIds
                            }
                        }
                    }
                }
            };
        default:
            return state;
    }
};

const showGroupEditorRegionsErrors = (
    state: EditGroupsState,
    action: ShowGroupEditorRegionsErrors
): EditGroupsState => {
    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...state.groups[action.groupId],
                errors: {
                    ...state.groups[action.groupId].errors,
                    regionIds: { errors: action.errors }
                }
            }
        }
    };
};

const performanceSuggestFeedItemClick = (
    state: EditGroupsState,
    action: SuggestFeedItemClickAction
): EditGroupsState => {
    const group = state.groups[action.groupId];
    const { feedId, ...rest } = group.errors;

    switch (group.value.campaignType) {
        case CampaignType.PERFORMANCE:
            return {
                ...state,
                groups: {
                    ...state.groups,
                    [action.groupId]: {
                        ...group,
                        value: {
                            ...group.value,
                            selectedFeedId: action.feedId
                        },
                        errors: rest
                    }
                }
            };
        default:
            return state;
    }
};

const clearErrorsGroupEditorRegions = (
    state: EditGroupsState,
    action: ClearErrorsGroupEditorRegions
): EditGroupsState => {
    const group = state.groups[action.groupId];
    const { errors } = group;

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                errors: getGroupsErrorsWithoutCurrentListErrors(errors, [
                    'regionIds'
                ])
            }
        }
    };
};

const moveNewGroupToCreatedReducer = (
    state: EditGroupsState,
    action: MoveNewGroupToCreatedAction
): EditGroupsState => {
    const group = state.groups[action.mockGroupId];

    if (group.value.campaignType !== CampaignType.PERFORMANCE) {
        return state;
    }

    return {
        ...state,
        errors: [],
        groups: {
            [action.realGroupId]: {
                ...group,
                value: {
                    ...group.value,
                    feedId: action.feedId
                },
                id: action.realGroupId,
                isNew: false
            }
        }
    };
};

const deleteRetargetingConditionFromGroup = (
    state: EditGroupsState,
    action: DeleteRetargetingConditionFromGroup
): EditGroupsState => {
    if (state.retargetingConditions === undefined) {
        return {
            ...state
        };
    }

    const newRetargetingConditions = [...state.retargetingConditions];
    newRetargetingConditions.splice(action.index, 1);

    return {
        ...state,
        retargetingConditions: newRetargetingConditions
    };
};

const resetRetargetingErrors = (
    state: EditGroupsState,
    action: ResetRetargetingErrorsAction
): EditGroupsState => {
    const group = state.groups[action.groupId];

    const { retargeting, ...otherGroupErrors } = group.errors;

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                errors: otherGroupErrors
            }
        }
    };
};

const setNewMinusPhraseDataByMassActions = (
    state: EditGroupsState,
    action: AcceptMinusPhraseGroupsMassActionsAction,
    fullState: State
): EditGroupsState => {
    const groups = state.groups;
    const { minusPhrasesRadio } = fullState.groupsEditMassActions[
        MassActionId.groupsEdit
    ].data;
    const {
        value,
        selectedLibraryListItems = []
    } = fullState.minusPhraseLibraryEditor.data[
        action.massActionId
    ].minusKeywordsEditor;

    const newGroupsData = Object.keys(groups).reduce(
        (acc: Record<GroupId, EditGroupData>, next) => {
            const libraryItems =
                fullState.minusPhraseLibraryEditor.libraryItems || [];

            let newSelectedLibraryList: MinusPhrasesShortLibraryItem[] = [];
            let newValue: string[] = [];

            if (minusPhrasesRadio === BulkReplacementRadio.REPLACE) {
                newSelectedLibraryList = selectedLibraryListItems.reduce(
                    (
                        selectedElems: MinusPhrasesShortLibraryItem[],
                        id: string
                    ): MinusPhrasesShortLibraryItem[] => {
                        const selectedItem = libraryItems.find(
                            (item: MinusPhrasesLibraryItem) => item.id === id
                        );

                        if (selectedItem) {
                            selectedElems.push({
                                id,
                                name: selectedItem.name
                            });
                        }

                        return selectedElems;
                    },
                    [] as MinusPhrasesShortLibraryItem[]
                );
                newValue = value;
            }

            const group: EditGroupData = groups[next];

            if (
                group.value.campaignType === CampaignType.TEXT &&
                group.isEditable
            ) {
                acc[next] = {
                    ...group,
                    value: {
                        ...group.value,
                        minusKeywords: newValue,
                        selectedLibraryList: newSelectedLibraryList
                    },
                    errors: {},
                    isSaved: false
                };
            } else {
                acc[next] = group;
            }

            return acc;
        },
        {}
    );

    return {
        ...state,
        groups: newGroupsData
    };
};

const updateProductsRestrictionId = (
    state: EditGroupsState,
    action: UpdateProductRestrictionIdAction
): EditGroupsState => {
    const group = state.groups[action.groupId];

    if (group.value.campaignType !== CampaignType.CPM_BANNER) {
        throw Error(
            `В группе с типом ${
                group.value.campaignType
            } нет возможности изменить набор условий показа`
        );
    }

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                value: {
                    ...group.value,
                    showConditionType: CpmGroupShowConditionType.USER_PROFILE,
                    productRestrictionId: action.id
                },
                errors: {}
            }
        }
    };
};

const updateShowConditionType = (
    state: EditGroupsState,
    action: UpdateShowConditionTypeAction
): EditGroupsState => {
    const { groups, productsList } = state;
    const group = groups[action.groupId];

    if (
        group.value.campaignType !== CampaignType.CPM_BANNER ||
        productsList === undefined
    ) {
        throw Error(
            `В группе с типом ${
                group.value.campaignType
            } нет возможности изменить набор условий показа`
        );
    }

    const restrictions = productsList[CampaignType.CPM_BANNER].restrictions;
    const restrictionByShowConditionType = getRestrictionByShowConditionType(
        action.showConditionType,
        restrictions
    );
    const productRestrictionId = restrictionByShowConditionType
        ? restrictionByShowConditionType.id
        : group.value.productRestrictionId;
    const { rateCurrentType, rateCorrections } = getCurrentRateTypeAndLists({
        productRestrictionId: productRestrictionId,
        rateCorrectionsFromApi: [],
        productsList: productsList
    });

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                value: {
                    ...group.value,
                    rateCurrentType,
                    rateCorrections,
                    showConditionType: action.showConditionType,
                    productRestrictionId
                }
            }
        }
    };
};

export function groupsMultiEdit(
    state: EditGroupsState = EditGroupsInitialState,
    action: Action,
    fullState: State
): EditGroupsState {
    switch (action.type) {
        case RESET_GROUPS_EDIT:
            return EditGroupsInitialState;

        case ACCEPT_MINUS_PHRASE_GROUPS_MASS_ACTIONS:
            return setNewMinusPhraseDataByMassActions(state, action, fullState);
        case GET_GROUPS_FOR_EDIT:
            return {
                ...state,
                pageStatus: PageStatus.LOADING
            };

        case GET_CAMPAIGN_BASIC_DATA:
            return {
                ...state,
                campaignsIds: [action.campaignId],
                pageStatus: PageStatus.LOADING,
                feedsPopupFetchFirstRun: true
            };

        case CREATE_SMART_AD_GROUP:
            return {
                ...state,
                errors: [],
                groups: {
                    ...state.groups,
                    [action.mockGroupId]: {
                        ...state.groups[action.mockGroupId],
                        errors: {}
                    }
                },
                pageStatus: PageStatus.SAVING
            };

        case SAVE_GROUPS:
            return {
                ...state,
                errors: [],
                pageStatus: PageStatus.SAVING
            };

        case UPDATE_DATA_FOR_EDIT_GROUPS:
            return {
                ...state,
                ...action.data,
                pageStatus: PageStatus.LOADED
            };

        case UPDATE_PRODUCTS_LIST:
            return {
                ...state,
                productsList: action.productsList
            };

        case UPDATE_RETARGETING_CONDITIONS_FOR_EDIT_GROUPS: {
            return {
                ...state,
                retargetingConditions: action.data.retargetingConditions
            };
        }

        case UPDATE_RETARGETING_CONDITIONS: {
            if (state.retargetingConditions === undefined) {
                return {
                    ...state
                };
            }

            let newRetargetingConditions = [...state.retargetingConditions];
            let newGroups = state.groups;

            const conditionIndex = findIndex(
                newRetargetingConditions,
                condition => {
                    return condition.id === action.condition.id;
                }
            );

            if (conditionIndex !== -1) {
                newRetargetingConditions[conditionIndex] = action.condition;

                newGroups = mapValues(state.groups, group => {
                    if (group.value.campaignType !== CampaignType.TEXT) {
                        return group;
                    }

                    return {
                        ...group,
                        value: {
                            ...group.value,
                            retargeting: group.value.retargeting.map(
                                (retargetingItem: RetargetingValue) => {
                                    if (
                                        retargetingItem.id ===
                                        action.condition.id
                                    ) {
                                        return {
                                            id: retargetingItem.id
                                        };
                                    }

                                    return retargetingItem;
                                }
                            )
                        }
                    };
                });
            } else {
                newRetargetingConditions = [
                    ...newRetargetingConditions,
                    action.condition
                ];
            }

            return {
                ...state,
                retargetingConditions: newRetargetingConditions,
                groups: newGroups
            };
        }

        case CHANGE_GROUP_NAME:
            return updateGroupName(state, action);

        case UPDATE_GROUP_TYPE:
            return updateGroupType(state, action);

        case CHANGE_GENERAL_RATE:
            return updateGroupGeneralRate(state, action);

        case AUDIENCE_TARGETING_TEMPLATE_NAME_CHANGE:
            return audienceTargetingTemplateNameChange(state, action);

        case CHANGE_AUDIENCE_VALUE:
            return changeAudienceValue(state, action);

        case CLEAR_GROUP_AUDIENCE_RETARGETING_CONDITION:
            return clearGroupAudienceRetargetingCondition(state, action);

        case SHOW_GROUP_EDIT_ERROR:
            return {
                ...state,
                errors: [...state.errors, String(action.error.text)],
                pageStatus: PageStatus.LOADED
            };

        case CHANGE_GROUP_EDIT_PAGE_STATUS:
            return {
                ...state,
                pageStatus: action.pageStatus
            };

        case UPDATE_GROUP_MINUS_PHRASES:
            return doneChangesGroupMinusKeywordsEditor(state, action);

        case INPUT_CHANGE_GROUP_EDITOR_MINUS_KEYWORDS:
            return inputChangeGroupMinusKeywordsEditor(state, action);

        case SHOW_GROUPS_PARTIAL_SAVE_RESULT:
            return {
                ...state,
                ...setSavedGroups(
                    state,
                    action.payload.updatedGroupIds,
                    action.payload.errors
                )
            };

        case SHOW_GROUPS_CLIENT_VALIDATION_ERRORS:
            return {
                ...state,
                pageStatus: PageStatus.LOADED,
                groups: mapValues(state.groups, group => {
                    return {
                        ...group,
                        errors: action.errorsData[group.id]
                            ? action.errorsData[group.id]
                            : group.errors
                    };
                })
            };

        case CLOSE_GROUP_EDIT_RECOMMENDATION:
            return {
                ...state,
                groups: {
                    ...state.groups,
                    [action.groupId]: {
                        ...state.groups[action.groupId],
                        showConditionsRecommendationData: {
                            wasClosed: true
                        }
                    }
                }
            };

        case UPDATE_PRODUCT_RESTRICTION_ID:
            return updateProductsRestrictionId(state, action);

        case UPDATE_SHOW_CONDITION_TYPE:
            return updateShowConditionType(state, action);

        case CHANGE_GROUP_SAVED_STATUS:
            return updateGroupSavedStatus(state, action);

        case CHANGE_GROUP_EDITOR_KEYWORDS:
            return updateGroupKeywordsEditor(state, action);

        case DONE_GROUP_EDITOR_KEYWORDS:
            return doneGroupKeywords(state, action);

        case OPEN_EDITOR_KEYWORDS:
            return openGroupOpenKeywordsEditor(state, action);

        case APPLY_SELECTOR_WIZARD_FOR_GROUP_EDIT:
            return applyGroupKeywordsFromSelectorWizard(
                state,
                action,
                fullState
            );

        case CHANGE_INPUT_GROUP_EDITOR_KEYWORDS:
            return inputChangeGroupKeywordsEditor(state, action);

        case CANCEL_GROUP_EDITOR_KEYWORDS:
            return cancelGroupKeywordsEditor(state, action);

        case UPDATE_GROUP_RATE_CORRECTIONS:
            return updateRateCorrections(state, action);

        case UPDATE_GROUP_AUDIENCE_TARGETING_INTERESTS:
            return updateInterestsTargetingSet(state, action);

        case UPDATE_GROUP_AUDIENCE_RETARGETING_CONDITION:
            return updateGroupAudienceRetargetingCondition(state, action);

        case UPDATE_GROUP_AUDIENCE_CRYPTA_SOCIAL_DEMO:
            return updateCryptaSocialDemo(state, action);

        case UPDATE_GROUP_OUTDOOR_MAP:
            return updateGroupOutdoorMap(state, action);

        case UPDATE_GROUP_INDOOR_MAP:
            return updateGroupIndoorMap(state, action);

        case CLEAR_OUTDOOR_ERRORS:
        case CLEAR_INDOOR_ERRORS:
            return clearGroupMapErrors(state, action);

        case UPDATE_GROUP_AUDIENCE_CRYPTA_GROUP_FAMILY:
            return updateCryptaGroupFamily(state, action);

        case UPDATE_GROUP_AUDIENCE_CRYPTA_AUDIO_GENRES:
            return updateCrcryptaAudioGenres(state, action);

        case UPDATE_GROUP_AUDIENCE_CRYPTA_BEHAVIORAL:
            return updateCryptaBehavioral(state, action);

        case TOGGLE_GROUP_AUTOTARGETING:
            return toggleGroupAutotargeting(state, action);

        case CHANGE_GROUP_RETARGETING: {
            return updateGroupRetargeting(state, action);
        }

        case CHANGE_GROUP_HREF_PARAMS:
            return updateGroupHrefParams(state, action);

        case CHANGE_GROUP_BANNER_HEADERS_FEED_FIELD:
            return updateGroupBannerHeadersFeedField(state, action);

        case PERFORMANCE_SET_VISIBLE_GROUP_BANNER_POPUP_FEED:
            return performanceSetVisibleGroupBannerPopupFeed(state, action);

        case PERFORMANCE_CHANGE_BANNER_FEED_SEARCH_TEXT:
            return performanceChangeBannerFeedSearchText(state, action);

        case PERFORMANCE_SUGGEST_FEED_ITEM_CLICK:
            return performanceSuggestFeedItemClick(state, action);

        case CHANGE_GROUP_BANNER_TEXT_FEED_FIELD:
            return updateGroupBannerTextFeedField(state, action);

        case OPEN_GROUP_FILTERS_LIST_EDITOR:
        case CLOSE_GROUP_FILTERS_LIST_EDITOR:
        case SET_GROUP_FILTERS:
        case GET_GROUP_FILTERS:
        case DELETE_GROUP_FILTER:
        case UPDATE_FILTERS_EDITOR_AUXILIARY_FILTER:
            return filtersReducer(state, action, fullState);

        case PERFORMANCE_SET_VISIBLE_FEED_MODAL:
            return {
                ...state,
                isPerformanceFeedModalOpen: action.isVisible
            };

        case ADD_SMART_FILTER_CONDITION:
        case REMOVE_SMART_FILTER_CONDITION:
        case CHANGE_SMART_FILTER_CONDITION_OPERATOR:
        case CHANGE_SMART_FILTER_CONDITION_FIELD:
        case CHANGE_SMART_FILTER_CONDITION_VALUES:
            return conditionsReducer(state, action);

        case UPDATE_GROUP_EDITOR_REGIONS:
            return updateGroupEditorRegions(state, action);

        case CLEAR_ERRORS_GROUP_EDITOR_REGIONS:
            return clearErrorsGroupEditorRegions(state, action);

        case SHOW_GROUP_EDITOR_REGIONS_ERRORS:
            return showGroupEditorRegionsErrors(state, action);

        case PERFORMANCE_UPDATE_FEEDS:
            return {
                ...state,
                feedsIds: action.feedsIds,
                feeds: action.feeds,
                feedsPopupFetchFirstRun: false
            };

        case MOVE_NEW_GROUP_TO_CREATED:
            return moveNewGroupToCreatedReducer(state, action);

        case DELETE_RETARGETING_CONDITION_FROM_GROUP:
            return deleteRetargetingConditionFromGroup(state, action);

        case OPEN_GROUP_FILTER_INSPECTOR:
        case CLOSE_GROUP_FILTER_INSPECTOR:
        case UPDATE_FEED_FILTER_SCHEMA:
        case SET_FILTER_FEED_CATEGORIES:
        case SELECT_AUTOBUDGET_PRIORITY_TYPE:
        case UPDATE_AUTOBUDGET_PRICE:
        case UPDATE_SMART_FILTER_NAME:
        case ADD_SMART_FILTER:
        case UPDATE_SMART_FILTER:
        case UPDATE_SMART_FILTER_AUDITORY:
        case UPDATE_SMART_FILTER_PRICE_RANGE:
        case UPDATE_SMART_FILTER_VENDORS:
        case TOGGLE_SMART_FILTER_AVAILABLE:
        case UPDATE_SMART_FILTER_CATEGORIES:
        case CHANGE_SMART_FILTER_TAB:
        case SET_SMART_FILTER_VALIDATION_ERRORS:
        case UPDATE_FILTERS_ERROR:
        case UPDATE_SMART_FILTER_SUCCESS:
            return groupFilterInspectorReducer(state, action);

        case CHANGE_ADDITIONAL_TARGETING_UIDS_VALUE:
        case CHANGE_ADDITIONAL_TARGETING_UIDS_CONTROL:
        case CANCEL_ADDITIONAL_TARGETING_CHANGES:
        case SAVE_ADDITIONAL_TARGETING_CHANGES:
        case CHANGE_INTERNAL_NETWORK_CONTROL:
        case CHANGE_IS_BROWSER_CONTROL:
        case CHANGE_IS_TABLET_CONTROL:
        case CHANGE_IS_TOUCH_CONTROL:
        case CHANGE_IS_MOBILE_CONTROL:
        case CHANGE_OS_NAMES_CONTROL:
        case CHANGE_OS_NAMES_VALUE:
        case CHANGE_OS_FAMILIES_CONTROL:
        case CHANGE_OS_FAMILIES_VALUE:
        case CHANGE_BROWSER_NAMES_VALUE:
        case CHANGE_BROWSER_NAMES_CONTROL:
        case CHANGE_BROWSER_ENGINES_VALUE:
        case CHANGE_BROWSER_ENGINES_CONTROL:
        case CHANGE_DEVICE_VENDORS_VALUE:
        case CHANGE_DEVICE_VENDORS_CONTROL:
        case CHANGE_DEVICE_NAMES_VALUE:
        case CHANGE_DEVICE_NAMES_CONTROL:
        case CHANGE_INTERFACE_LANGS_VALUE:
        case CHANGE_INTERFACE_LANGS_CONTROL:
        case CHANGE_QUERY_REFERERS_VALUE:
        case CHANGE_QUERY_REFERERS_CONTROL:
        case CHANGE_USER_AGENTS_VALUE:
        case CHANGE_USER_AGENTS_CONTROL:
        case CHANGE_PRIORITY_VALUE:
        case OPEN_ADDITIONAL_TARGETING_INTERNAL:
        case CLOSE_ADDITIONAL_TARGETING_INTERNAL:
        case SAVE_INTERNAL_GROUPS:
            return groupsEditInternal(state, action, fullState);
        case RESET_RETARGETING_ERRORS:
            return resetRetargetingErrors(state, action);
        case CLOSE_RECOMMENDATIONS_FOR_GROUPS_EDIT:
            return closeGroupsEditRecommendations(state, action);
        case UPDATE_RECOMMENDATIONS_FOR_GROUPS_EDIT:
            return updateRecommendationData(state, action);

        default:
            return state;
    }
}
